module.exports = __webpack_public_path__ + "img/faq_mentors.fa1e8b0b.jpg";